module.exports = __webpack_public_path__ + "img/user_card.9fe5faa3.svg";